module.exports = __webpack_public_path__ + "static/media/1_A1_24.f3b0341e.png";